module.exports = __webpack_public_path__ + "static/media/za.da9e50f2.svg";